module.exports = __webpack_public_path__ + "static/media/2.38e7952a.jpg";